<div class="logo" [class.hidden]="hide">
    <img *ngIf="logo && logo.length" class="full-logo" [src]="logo" >
    <img *ngIf="sublogo && sublogo.length" class="sub-logo" [src]="sublogo" >
</div>
